export const getExtensionFromMimeType = (mimeType) => {
  const extensions = {
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/webp': '.webp',
    'image/heic': '.heic',
    'image/heif': '.heif'
  }
  return extensions[mimeType] || '.jpg' // fallback to jpg if unknown type
}